<template>
    <v-dialog v-model="show" max-width="500px" min-height="800px" persistent>
      <v-card>
        <v-card-title style="display: flex; justify-content: center">
          {{ $t('location.selectLocation') }}
        </v-card-title>
        <v-card-text>
          <v-select
              v-model="selectedLocation"
              :item-text="item => `${item.location_id} - ${item.name}`"
              :items="locationsDetails"
              return-object/>
        </v-card-text>
        <v-card-actions class="pa-0 mt-4">
          <v-btn
              color="primary"
              style="width: 50%;"
              tile
              @click="validate()"
          >{{ $t('subOrder.confirm') }}
          </v-btn>
          <v-btn
              class="ml-0"
              color="secondary"
              style="width: 50%;"
              tile
              @click="close()"
          >{{ $t('subOrder.close') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
</template>

<script>
import { mapActions } from 'vuex'
import { EventBus } from '../../event-bus'

export default {
  name: 'selectionLocationDialog',
  data () {
    return {
      locationsDetails: [],
      selectedLocation: null
    }
  },
  props: {
    userLocations: {
      type: Array,
      required: true
    },
    currentStore: {
      type: [Object, undefined]
    },
    value: {
      type: Boolean,
      default: false
    },
    isAdmin: {
      type: Boolean,
      default: false
    },
    isShopManager: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    show: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      }
    }
  },
  watch: {
    userLocations: {
      async handler () {
        this.locationsDetails = await this.getStores()
      },
      deep: true
    },
    currentStore: {
      handler () {
        this.selectedLocation = this.currentStore
      },
      deep: true
    }
  },
  async mounted () {
    this.locationsDetails = await this.getStores()
    this.selectedLocation = this.currentStore
  },
  methods: {
    ...mapActions(['setCurrentStoreDetails', 'setCurrentStore']),
    async getStores () {
      const myInit = {
        headers: {
          Authorization: `Bearer ${this.$auth.accessToken}`
        },
        queryStringParameters: {
          itemsPerPage: false,
          filters: JSON.stringify({
            location_id: this.userLocations
          }),
          fields: ['location_id', 'name', 'address']
        }
      }
      try {
        const response = await this.$Amplify.API.get('locations', '/v1/int/locations', myInit)
        return response.data
      } catch (e) {
        console.log(e)
      }
    },
    validate () {
      if (this.selectedLocation !== this.currentStore) {

        this.setCurrentStoreDetails(this.selectedLocation)
        this.setCurrentStore(this.selectedLocation?.location_id)

        const needToBeAdminOrShopManager = ['subOrderDetails']

        if (needToBeAdminOrShopManager.includes(this.$route.name) && !this.isAdmin && !this.isShopManager) {
          this.$router.push('/')
        } else {
          EventBus.$emit('reloadComponent')
        }

        EventBus.$emit('reLoadCounter')

      }
      this.close()
    },
    close () {
      this.$emit('close')
    }
  }
}
</script>